import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Button } from '@/components/ui/button/button.component';
import { cn } from '@/utils/cn-tw-merge';

interface ArrivalOrderSlotButtonProps {
  start: string;
  end: string;
  busy?: boolean;
  className?: string;
  onClick?: () => void;
}

export function ArrivalOrderSlotButton({
  start,
  end,
  busy = false,
  className,
  onClick,
}: ArrivalOrderSlotButtonProps) {
  return (
    <Button
      variant="secondary"
      color="primary"
      className={cn(
        'whitespace-normal py-1.5 xl:py-2 text-sm xl:text-base',
        busy && 'opacity-60 cursor-progress',
        className,
      )}
      aria-disabled={busy}
      aria-busy={busy}
      data-testid={DataTestIdEnum.SEARCH_CARD_ARRIVAL_ORDER_SLOT_BUTTON}
      onClick={onClick}
    >
      {`${start} às ${end}`}
    </Button>
  );
}
